export const AsyncStatus = ({ status, onDefault, onLoading, onComplete, onError }) => {
	if (status === "default") return onDefault ? onDefault() : null;
	if (status === "loading") return onLoading ? onLoading() : null;
	if (status === "complete") return onComplete ? onComplete() : null;
	if (status === "error") return onError ? onError() : null;

	return null;
};

export default AsyncStatus;